import { useNavigate, useSearch } from "@tanstack/react-router";
import { useMemo } from "react";

import useAnalytics from "@/hooks/use-analytics";
import type { ExploreSearchParams } from "@/routes/explore/index";

import { DEFAULT_SORT_OPTION } from "../contants";
import type { SortEnum } from "../types";
import useSortMenuOptions from "./use-sort-menu-options";

export default function useSelectedSortOption(
  onChange = () => {
    /* No-op */
  }
): [SortEnum, (sortBy: SortEnum) => void] {
  const search = useSearch({ strict: false }) as ExploreSearchParams;
  const navigate = useNavigate();
  const { track } = useAnalytics();
  const options = useSortMenuOptions();

  const option = useMemo(() => {
    if (!search.sortBy) {
      return DEFAULT_SORT_OPTION;
    }

    const sortBy = search.sortBy as SortEnum;

    if (sortBy in options) {
      return sortBy;
    }

    return DEFAULT_SORT_OPTION;
  }, [search, options]);

  const setOption = (sortBy: string) => {
    if (sortBy === option) {
      return;
    }

    track("Games Sorted", { sort_order: sortBy });

    navigate({ search: (prev: ExploreSearchParams) => ({ ...prev, sortBy }) });

    onChange();
  };

  return [option, setOption];
}
